export default __webpack_public_path__ + "static/media/redo.b0e0910e.svg";